import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Button, Button2 } from "components";
import { ConfirmFailIcon, ConfirmSuccessIcon } from "icons";

import {
  GetMessageHistoryListFilterActionCreators,
  ResendMessageActionCreators,
} from "redux/rootActions";
import {
  resendMessageDataResponse,
  selectIsLoading,
} from "redux/messagemanagement/resendMessage/resendMessageStates";
import { httpStatus } from "configs/httpStatus";

import {
  Text,
  ButtonContainer,
  ConfirmModalStyled,
  ConfirmBtnStyled,
  FailText,
  TextConfirm,
  ConfirmContainer2,
  ButtonStyled2,
} from "./MessageDelivery.style";
import Loading from "components/loading2";

interface IResendMessageModal {
  handleCancel: () => void;
  messageID: number;
  params: any;
}

const ConfirmResendingModal: React.FC<IResendMessageModal> = ({
  handleCancel,
  messageID,
  params,
}) => {
  const { t }: any = useTranslation("translation", {
    keyPrefix: "message-delivery",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });

  const dispatch = useDispatch();
  const resendMessageData = useSelector(resendMessageDataResponse);
  const isLoading = useSelector(selectIsLoading);

  const [isVisibleNotification, setIsVisibleNotification] = useState({
    type: "",
    status: false,
  });

  useEffect(() => {
    dispatch(ResendMessageActionCreators.handleResetAction());
  }, []);

  const handleCancelSendMessageModal = () => {
    dispatch(ResendMessageActionCreators.handleResetAction());
    handleCancel();
    dispatch(
      GetMessageHistoryListFilterActionCreators.messageHistoryListAction({
        ...params,
        page: 1,
      })
    );
  };

  const handleConfirmMessage = () => {
    setIsVisibleNotification({
      ...isVisibleNotification,
      type: "success",
      status: true,
    });
  };

  const handleFailMessage = () => {
    setIsVisibleNotification({
      ...isVisibleNotification,
      type: "fail",
      status: true,
    });
  };

  const handleCancelNotication = () => {
    setIsVisibleNotification({ type: "", status: false });
    handleCancelSendMessageModal();
  };

  useEffect(() => {
    if (resendMessageData) {
      if (resendMessageData.status === httpStatus.StatusOK) {
        handleConfirmMessage();
      } else {
        handleFailMessage();
      }
    }
  }, [resendMessageData]);

  const SuccessModal = () => (
    <ConfirmModalStyled
      type="form"
      title=""
      visible={isVisibleNotification.status}
      onCancel={handleCancelNotication}
    >
      <div style={{ textAlign: "center", marginTop: 24 }}>
        <ConfirmSuccessIcon />

        <Text
          size={36}
          lnHeight="36px"
          weight={700}
          color="#2ac769"
          mg="12px 0px 24px"
        >
          配信完了
        </Text>
        <Text size={16} lnHeight="24px" weight={400}>
          無事配信完了しました。
        </Text>
        <Text size={16} lnHeight="24px" weight={400} mg="0px 0px 24px">
          このウィンドウを閉じてください。
        </Text>
        <ConfirmBtnStyled
          background="#E0E0E0"
          color="#FFFFFF"
          padding="11px 96px 13px"
          name="閉じる"
          border="none"
          bdr="6px"
          fontSize={16}
          lineHeight="16px"
          onClick={handleCancelNotication}
        />
      </div>
    </ConfirmModalStyled>
  );

  const FailureModal = () => (
    <ConfirmModalStyled
      type="form"
      title=""
      visible={isVisibleNotification.status}
      onCancel={handleCancelNotication}
    >
      <div style={{ textAlign: "center", marginTop: 24 }}>
        <ConfirmFailIcon />
        <Text
          size={36}
          lnHeight="36px"
          weight={700}
          color="#fb4e4e"
          mg="20px 0px 24px"
        >
          送信失敗
        </Text>
        <FailText size={16} lnHeight="24px" weight={400} mg="0px 0px 48px">
          メッセージの送信に失敗しました
        </FailText>
        <ConfirmBtnStyled
          background="#E0E0E0"
          color="#FFFFFF"
          padding="11px 96px 13px"
          name="閉じる"
          border="none"
          bdr="6px"
          fontSize={16}
          lineHeight="16px"
          onClick={handleCancelNotication}
        />
      </div>
    </ConfirmModalStyled>
  );

  const renderNotificationModal = () => {
    if (isVisibleNotification.type === "success") {
      return <SuccessModal />;
    }
    return <FailureModal />;
  };

  const renderSendMessageModal = () => {
    return (
      <ConfirmContainer2>
        <TextConfirm>
          <div>送信失敗したメッセージを再度配信します。</div>
          <div>よろしいですか？</div>
        </TextConfirm>
        <ButtonContainer>
          <ButtonStyled2
            background="#E0E0E0"
            color="#FFFFFF"
            padding="13px 24px 11px"
            name="キャンセル"
            border="none"
            bdr="6px"
            fontSize={16}
            height="40px"
            fontWeight={700}
            lineHeight="16px"
            onClick={handleCancel}
          />
          <ButtonStyled2
            background="#2AC769"
            color="#FFFFFF"
            padding="13px 48px 11px"
            name="はい"
            border="none"
            bdr="6px"
            fontSize={16}
            fontWeight={700}
            lineHeight="16px"
            disabled={isLoading}
            loading={isLoading}
            height="40px"
            onClick={() => {
              // setIsVisibleConfirm(false);
              dispatch(
                ResendMessageActionCreators.resendMessageAction({
                  id: messageID,
                })
              );
            }}
          />
        </ButtonContainer>
      </ConfirmContainer2>
    );
  };

  return (
    <>
      {isVisibleNotification.status
        ? renderNotificationModal()
        : renderSendMessageModal()}
    </>
  );
};

export default ConfirmResendingModal;
